import { isMobile, isLogin } from '../utils.js';


export default function () {
    if (isMobile) {
        let menu_dialog = null
        $('#header-nav').click(function(){
            if (!menu_dialog) {
                menu_dialog = $(`
                <div class="fixed menu_dialog " style="display: block;">
        <div class="close_menu absolute   ">
            <img loading="lazy" src="${public_domain}/images/user_ico26_hover.png" alt="关闭" class="w-full h-full">
        </div>
    
        <div class="menu-title">运输人服务</div>
        <div class="flex  menu-list-ul  box-border  ">
            <div class="flex-1"><a class="flex-center text-white bg-[#f1a71b] w-full" href="/about-us.html" target="_self">关于我们</a></div>
            <div class="flex-1"><a class="flex-center text-white bg-[#f1a71b] w-full" href="/link-us.html" target="_self">联系我们</a></div>
            <div class="flex-1"><a class="flex-center text-white bg-[#f1a71b] w-full" href="/join-us.html" target="_self">加入我们</a></div>
            <div class="flex-1"><a class="flex-center text-white bg-[#f1a71b] w-full" href="/feed-book.html" target="_self">意见反馈</a></div>
        </div>
        <!--中英文切换-->
        <div class="menu-title">语言切换</div>
        <div class="flex menu-lang  box-border ">
            <div class="flex items-center  bg-gray-200">
                <a href="//www.yunshuren.com" class="flex items-center  w-full " target="_self">
                    <img loading="lazy" src="${public_domain}/images/cn.jpg">CN</a>
            </div>
            <div class="flex items-center ">
                <a href="//en.yunshuren.com" target="_self" class="flex items-center  w-full">
                    <img loading="lazy"  src="${public_domain}/images/en.jpg">EN</a>
            </div>
        </div>
        <!--中英文切换-->
        <div class="menu-title">其他站点</div>
        <div class="flex   box-border site-list">
            <a href="http://www.qichejingwei.com/" target="_self" class="bg-gray-200  ">
                <img loading="lazy" src="${public_domain}/images/qichejingwei.png" alt="汽车经纬">
            </a>
            <a href="https://union.yunshuren.com" target="_self" class="bg-gray-200 ">
                <img loading="lazy" src="${public_domain}/images/union.png" alt="运能联盟">
            </a>
        </div>
    </div>
                `)
                $('body').append(menu_dialog)
                menu_dialog.on('click', '.close_menu', function(){
                    menu_dialog.animate({
                        left: '100%'
                    }, 300, () => {
                        menu_dialog.hide()
                    })
                })
            }

            menu_dialog.show().animate({
                left: 0
            }, 300)
        })
        let search_box

        $('#search').click(function(){
            if (!search_box) {
                search_box = $(`
                <div class="search_box fixed">
                    <div class="search_head_box ">
                        <div class="search_back">
                            <img loading="lazy" src="${public_domain}/images/back_icon_dialog.png">
                        </div>
                        <div class="search-input flex items-center flex-1 border  overflow-hidden">
                            <img loading="lazy"  src="${public_domain}/images/search_gray.png">
                            <input class="outline-none flex-1 h-full " type="search" value="" name="keyword" placeholder="请录入您要查找的内容">
                        </div>
                        <div class="flex-center rounded-sm bg-ysr-green text-white " id="mobile_search_btn">
                            搜索
                        </div>
                    </div>

                    <div class="search_kw_type show_info flex ">
                        <div type="" class="current flex-1 h-full flex-center transition-all" target="_self">信息</div>
                        <div type="1" class="info_btn flex-1 h-full flex-center bg-[#64c1ba] text-white border-l border-l-white transition-all" target="_self">资讯</div>
                        <div type="2" class="info_btn flex-1 h-full flex-center bg-[#64c1ba] text-white border-l border-l-white transition-all" target="_self">视频</div>
                        <div type="3" class=" flex-1 h-full flex-center transition-all" target="_self">品牌</div>
                        <div type="4" class=" flex-1 h-full flex-center transition-all" target="_self">英雄帖</div>
                    </div>
                </div>
                `)

                $('body').append(search_box);

                let search_input = search_box.find('input')
                $('.search_kw_type').on('click', '.flex-center', function () {

                    type = $(this).attr('type');
                    if (type >= 3) {
                        $('.search_kw_type .info_btn').hide()
                    } else {
                        $('.search_kw_type .info_btn').show()
                    }
                    $(this).addClass('current').siblings().removeClass('current')
                })
                $('.search_box ').on('click', '.search_back', function () {
                    search_box.animate({
                        left: '100%'
                    }, 300, () => {
                        search_box.hide()
                    })
                })
                $('#mobile_search_btn ').on('click', function () {
                    var keyword = search_input.val();
                    if ('' == keyword) return false;
                    var type = '';
                    var url = "//" + global_info.main_domain + "/search-" + keyword;
                    if('' != type) url += "-" + type;
                    url += ".html";
                    window.location.href = url;
                })

            }
            search_box.show().animate({
                left: 0
            }, 300)

            setTimeout(() => {
                search_box.find('input').focus();
            }, 316);
        })
        let type
        


    }
}